export const COMPUTED_KEYS = new Set(["occupancy_percentage", "hotel_revenue", "total_revenue", "actual_deposit",
  "pms_total", "pms_cc_total", "rest_total", "rest_cc_total"]);

// Tolerant numeric parse: handles values stored as strings with thousands
// separators ("7,496.77"), currency symbols, spaces, or ( ) negatives.
// Returns NaN when the value isn't numeric.
export function toNum(v) {
  if (v === "" || v == null) return NaN;
  if (typeof v === "number") return v;
  let s = String(v).trim();
  const neg = /^\(.*\)$/.test(s) || s.startsWith("-");
  s = s.replace(/[^0-9.]/g, "");
  if (s === "" || s === ".") return NaN;
  const num = Number(s);
  if (isNaN(num)) return NaN;
  return neg ? -Math.abs(num) : num;
}

export function computeCell(key, row, defaultRooms = 0) {
  const n = (k) => {
    const v = toNum(row?.[k]);
    return isNaN(v) ? 0 : v;
  };
  if (key === "occupancy_percentage") {
    let ra = row?.rooms_available;
    ra = ra === "" || ra == null ? Number(defaultRooms || 0) : toNum(ra);
    if (isNaN(ra)) ra = Number(defaultRooms || 0);
    return ra ? n("rooms_sold") / ra : 0;
  }
  if (key === "hotel_revenue")
    return n("room_revenue") + n("f_b_revenue") + n("pantry_revenue") + n("misc_revenue") + n("meeting_room");
  if (key === "actual_deposit")
    return n("fd_checks_dropped") + n("fd_cash_dropped") + n("reported_cash_drop");
  if (key === "pms_total") return n("pms_visa") + n("pms_mastercard") + n("pms_discover");
  if (key === "pms_cc_total") return n("pms_visa") + n("pms_mastercard") + n("pms_discover") + n("pms_amex");
  if (key === "rest_total") return n("rest_visa") + n("rest_mastercard") + n("rest_discover");
  if (key === "rest_cc_total") return n("rest_visa") + n("rest_mastercard") + n("rest_discover") + n("rest_amex");
  if (key === "total_revenue")
    return n("room_revenue") + n("f_b_revenue") + n("pantry_revenue") + n("misc_revenue") + n("meeting_room");
  return null;
}

export function fmtCell(type, v) {
  if (v === "" || v == null || isNaN(Number(v))) return "";
  const num = Number(v);
  if (type === "currency") return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  if (type === "percent") return `${(num * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
  return num.toLocaleString();
}

// Strip currency symbols, thousands separators, %, spaces from pasted/typed numeric values
export function sanitizeNumeric(raw) {
  if (raw == null) return "";
  let s = String(raw).trim();
  if (s === "") return "";
  const negative = s.startsWith("-") || /^\(.*\)$/.test(s);
  s = s.replace(/[^0-9.]/g, "");
  if (s === "" || s === ".") return "";
  return negative ? `-${s}` : s;
}
